import React, { PureComponent } from 'react';
import Lightbox from 'react-images';

// Styles
import {
  StyledGalleryWrapper,
  StyledGalleryItem,
  StyledGalleryItemOverlay,
} from "./gallery.style";

import {
  StyledElementWrapperCenter,
  StyledElementHeaderTitle,
  StyledElementHeaderDescription,
} from 'styledElements';

// Icons
import IconZoom from 'icons/zoom.icon';


class Gallery extends PureComponent {

  state = {
    lightboxIsOpen: false,
    currentImage: 0,
  };

  openLightbox = (index, event) => {
    event.preventDefault();
    this.setState({
      currentImage: index,
      lightboxIsOpen: true,
    });
  };

  closeLightbox = () => {
    this.setState({
      currentImage: 0,
      lightboxIsOpen: false,
    });
  };
  gotoPrevious = () => {
    this.setState({
      currentImage: this.state.currentImage - 1,
    });
  };

  gotoNext = () => {
    this.setState({
      currentImage: this.state.currentImage + 1,
    });
  };

  gotoImage = (index) => {
    this.setState({
      currentImage: index,
    });
  };

  handleClickImage = () => {
    if (this.state.currentImage === this.props.images.length - 1) return;

    this.gotoNext();
  };

  renderGallery = () => {
    const { images } = this.props;

    const gallery = images.map((obj, i) => {
      return (
        <StyledGalleryItem
          href={obj.src}
          key={i}
          onClick={(e) => this.openLightbox(i, e)}
        >
          <StyledGalleryItemOverlay>
            <IconZoom/>
          </StyledGalleryItemOverlay>
          <img alt="" src={obj.src}  />
        </StyledGalleryItem>
      );
    });

    return (
      <div>
        {gallery}
      </div>
    );
  };

  renderFullGallery = (title, description) => <StyledGalleryWrapper>
    <StyledElementWrapperCenter>
      <header>
        <StyledElementHeaderTitle>
          {title}
        </StyledElementHeaderTitle>
        <StyledElementHeaderDescription>
          {description}
        </StyledElementHeaderDescription>
      </header>
      {this.renderGallery()}
      <Lightbox
        currentImage={this.state.currentImage}
        images={this.props.images}
        isOpen={this.state.lightboxIsOpen}
        onClickImage={this.handleClickImage}
        onClickNext={this.gotoNext}
        onClickPrev={this.gotoPrevious}
        onClickThumbnail={this.gotoImage}
        onClose={this.closeLightbox}
        preventScroll={true}
        showThumbnails={true}
        showImageCount={false}
      />
    </StyledElementWrapperCenter>
  </StyledGalleryWrapper>;

  renderSinglePhoto = () => <StyledGalleryWrapper>
    <StyledElementWrapperCenter>
      {this.renderGallery()}
      <Lightbox
        currentImage={this.state.currentImage}
        images={this.props.images}
        isOpen={this.state.lightboxIsOpen}
        onClickImage={this.handleClickImage}
        onClickNext={this.gotoNext}
        onClickPrev={this.gotoPrevious}
        onClickThumbnail={this.gotoImage}
        onClose={this.closeLightbox}
        preventScroll={true}
        showThumbnails={true}
        showImageCount={false}
      />
    </StyledElementWrapperCenter>
  </StyledGalleryWrapper>;

  render() {
    const { title, description } = this.props;
    return title ? this.renderFullGallery(title, description) : this.renderSinglePhoto();
  }
}

export default Gallery;


// WEBPACK FOOTER //
// ./src/components/gallery/gallery.component.js